export default "__VITE_ASSET__BbzKGqvx__"